export default "__VITE_ASSET__D5lm387h__"